import { Environment } from './environment.interface';

export const environment: Environment = {
	name: 'dev2',
	production: true,
	clientId: 'orchestrate_client',
	manageApiUrl: 'https://connect-x-orchestration-manage-westus2-2.dev.commandcentral.com/api',
	acsConnectorApiUrl: '',
	acsConnectorAUApiUrl: '',
	developmentMode: true,
	clientHost: 'orchestrate-westus2.dev.commandcentral.com',
	singlePreprod: true,
	admin2ApiUrl: 'https://admin-api.pi.commandcentral.com/api/admin-v2',
	pendoEnabled: false,
	pendoJsFilePath: '',
	admin2Url: 'https://admin2.pi.commandcentral.com',
};

// Variables specifying the maximum depth of chained and failover nodes.
export const MAX_CHAIN_DEPTH = 2;
export const MAX_FAILOVER_DEPTH = 2;

// Going to make this a per env variable
export const ORCHESTRATE_SCOPE = 'connectx_orchestrate';

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
